import type React from 'react';

import { Ban, Heart, Check } from '../../../../../../../../mads/icons';

export interface TileConfig {
    iconComponent?: React.FunctionComponent<{ color: string }>;
    baseColor: 'success' | 'alert' | 'warning' | 'neutral' | 'info';
    borderColor?: string;
}

export enum TileVariant {
    RedLightMismatchBanIcon,
    GreenLightMatchGreenText,
    YellowLightMatchNoIcon,
    GreenLightMatchGreenTextWithHeartIcon,
}

export function getTileVariant({
    isMatch,
    isNegativeMatch,
    isJobPreference,
}: {
    isMatch: boolean;
    isNegativeMatch: boolean;
    isJobPreference?: boolean;
}): TileVariant {
    if (isMatch) {
        return isJobPreference
            ? TileVariant.GreenLightMatchGreenTextWithHeartIcon
            : TileVariant.GreenLightMatchGreenText;
    } else if (isNegativeMatch) {
        return TileVariant.RedLightMismatchBanIcon;
    } else {
        return TileVariant.YellowLightMatchNoIcon;
    }
}

export const tileConfigs: { [_key in TileVariant]: TileConfig } = {
    [TileVariant.RedLightMismatchBanIcon]: {
        iconComponent: Ban,
        baseColor: 'warning',
    },
    [TileVariant.GreenLightMatchGreenTextWithHeartIcon]: {
        iconComponent: Heart,
        baseColor: 'success',
    },
    [TileVariant.GreenLightMatchGreenText]: {
        iconComponent: Check,
        baseColor: 'success',
    },
    [TileVariant.YellowLightMatchNoIcon]: {
        baseColor: 'neutral',
    },
};
